import React from 'react';
import { cn } from '@/utils/common-helpers';
import Image from 'next/image';

export function FeaturesSectionHoverEffectsMern() {
    const features = [
        {
            title: 'Custom CMS Development',
            description:
                'Unlock comprehensive development assistance for custom CMS solutions tailored to align with your specific requirements seamlessly. Our offerings ensure optimal value, delivering meticulously crafted and expertly deployed solutions enriched with interactive, user-friendly features. Experience the perfect alignment of CMS capabilities with your diverse business operations, providing you with the ideal perspective on managing your content effectively.',
            icon: '/img/technology/ic-cakephp-cms-development.svg',
        },
        {
            title: 'Enterprise Development Solutions',
            description:
                'As a distinguished MERN development company, we specialize in crafting immersive application frameworks and solutions tailored for enterprises. Leveraging the versatility of the JavaScript-based MERN stack, we meticulously select the optimal frontend and backend frameworks to deliver robust and reliable solutions, empowering your enterprise functions to thrive according to your business requirements.',
            icon: '/img/technology/ic-enterprise-solution.svg',
        },
        {
            title: 'Migration & Integration',
            description:
                'Businesses on legacy systems seeking to upgrade to more effective and relevant technical support find comprehensive solutions through our end-to-end MERN offerings. Our approach ensures a seamless migration and integration process, aligning with the latest technological utilities and services equipped with advanced MERN stack capabilities.',
            icon: '/img/technology/ic-migration-upgradation.svg',
        },
        {
            title: 'Support and Maintenance',
            description:
                "Equipped with state-of-the-art facilities and advanced tech-enabled processes, we cater to all your MERN stack development solution requirements. Benefit from top-notch MERN support and maintenance services adhering to rigorous service protocols, ensuring high uptime to keep your MERN solution running smoothly in all scenarios.",
            icon: '/img/technology/ic-support-maintenance.svg',
        },
        {
            title: 'Web Services and API Development',
            description:
                'Our MERN stack developers are dedicated to delivering optimal functional value through web services and API development tailored to your needs. We employ resourceful practices to provide the finest services, offering effective solutions for API configuration and feature integration utilizing RESTful web services powered by MERN.',
            icon: '/img/technology/ic-api-development.svg',
        },
        {
            title: 'SPA and Real-time App Development',
            description:
                'Experience advanced web solutions facilitating real-time customer engagement with dynamic single-page application (SPA) development. Leveraging the best features of React, our MERN stack developers craft engagement-centric single HTML pages, enabling swift business promotions and strategic user funnel creation through paid promotion techniques.',
            icon: '/img/technology/ic-spas.svg',
        },
    ];
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  relative z-10 max-w-7xl mx-auto">
            {features.map((feature, index) => (
                <Feature key={feature.title} {...feature} index={index} total={features.length} />
            ))}
        </div>
    );
}

const Feature = ({
    title,
    description,
    icon,
    index,
    total,
}: {
    title: string;
    description: string;
    icon: string;
    index: number;
    total: number;
}) => {
    return (
        <div
            className={cn(
                'flex flex-col py-[30px] relative group/feature dark:border-neutral-800',
                index % 3 === 0 && 'lg:border-l dark:border-neutral-800',
                (index + 1) % 3 !== 0 && 'lg:border-r dark:border-neutral-800',
                index >= 3 && 'lg:border-t dark:border-neutral-800 ',
                index === 5 && 'dark:border-neutral-800 ',
                index === 5 && total % 2 === 0 && 'mb-[-1.2px]',
            )}
        >
            {index < 3 && (
                <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-t from-[#F5F6F9] dark:from-neutral-800 to-transparent pointer-events-none" />
            )}
            {index >= 3 && (
                <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-b from-[#F5F6F9] dark:from-neutral-800 to-transparent pointer-events-none" />
            )}
            <div className="mb-[10px] relative z-10 px-10 text-neutral-600 dark:text-neutral-400">
                <Image src={icon} width={36} height={36} alt={title} title={title} className="" />
            </div>
            <div className="text-2xl font-bold mb-[10px] relative z-10 px-[30px]">
                <div className="absolute left-0 inset-y-0 h-6 group-hover/feature:h-8 w-1 rounded-tr-full rounded-br-full bg-neutral-300 dark:bg-neutral-700 group-hover/feature:bg-primary transition-all duration-200 origin-center" />
                <span className="group-hover/feature:translate-x-2 group-hover/feature:text-primary transition duration-200 inline-block text-neutral-800 dark:text-neutral-100">
                    {title}
                </span>
            </div>
            <p className="text-[#4C5773] mb-0 text-base text-neutral-600 dark:text-neutral-300 relative z-10 px-[30px]">
                {description}
            </p>
        </div>
    );
};
